import { useGetAllUserProxiesQuery } from "@RTKQuery/user/purchases/purchases";
import style from "./MyProxiesPage.module.scss";
import { ControlPanel, PaginationContainer, QueryParamsManager, Table } from "./components";
import { useAppSelector } from "store/hooks";

export function MyProxiesPage() {
    const { activePaginationPage, activePaginationLimit, activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage);

    const { data } = useGetAllUserProxiesQuery({
        page: activePaginationPage,
        limit: activePaginationLimit,
        search: activeSearchParameter,
        tag_ids: activeTags
    }, {
        pollingInterval: 5000,
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true,
        skipPollingIfUnfocused: true
    });

    return (
        <main className={style.page}>
            <ControlPanel />
            {
                data?.count_items
                    ? <Table />
                    : <p className={style.empty}>Активних проксі немає <QueryParamsManager /> </p>
            }
            <PaginationContainer />
            <QueryParamsManager />
            
        </main>
    )
}